'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FilledInfoIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="FilledInfoIcon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0C14.6957 0 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20Z"
          fill="#D8DCE5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.857 11.4286C22.857 12.1863 22.556 12.913 22.0202 13.4489C21.4844 13.9847 20.7577 14.2857 19.9999 14.2857C19.2421 14.2857 18.5154 13.9847 17.9796 13.4489C17.4438 12.913 17.1428 12.1863 17.1428 11.4286C17.1428 10.6708 17.4438 9.94407 17.9796 9.40825C18.5154 8.87243 19.2421 8.57141 19.9999 8.57141C20.7577 8.57141 21.4844 8.87243 22.0202 9.40825C22.556 9.94407 22.857 10.6708 22.857 11.4286ZM13.9285 28.5714C13.9285 27.5857 14.7285 26.7857 15.7142 26.7857H18.2142V20.3571H17.1428C16.6692 20.3571 16.2149 20.169 15.8801 19.8341C15.5452 19.4992 15.357 19.045 15.357 18.5714C15.357 18.0978 15.5452 17.6436 15.8801 17.3087C16.2149 16.9738 16.6692 16.7857 17.1428 16.7857H19.9999C20.9856 16.7857 21.7856 17.5857 21.7856 18.5714V26.7857H24.2856C24.5201 26.7857 24.7523 26.8319 24.969 26.9216C25.1856 27.0114 25.3825 27.1429 25.5483 27.3087C25.7141 27.4745 25.8457 27.6714 25.9354 27.888C26.0251 28.1047 26.0713 28.3369 26.0713 28.5714C26.0713 28.8059 26.0251 29.0381 25.9354 29.2548C25.8457 29.4714 25.7141 29.6683 25.5483 29.8341C25.3825 29.9999 25.1856 30.1315 24.969 30.2212C24.7523 30.3109 24.5201 30.3571 24.2856 30.3571H15.7142C15.2406 30.3571 14.7864 30.169 14.4515 29.8341C14.1166 29.4992 13.9285 29.045 13.9285 28.5714Z"
          fill="#3D517B"
        />
      </svg>
    </SvgIcon>
  )
}

FilledInfoIcon.propTypes = {
  sx: PropTypes.object
}
